import { render, staticRenderFns } from "./TaxDashboard.vue?vue&type=template&id=672e29d7&scoped=true"
import script from "./TaxDashboard.vue?vue&type=script&lang=js"
export * from "./TaxDashboard.vue?vue&type=script&lang=js"
import style0 from "./TaxDashboard.vue?vue&type=style&index=0&id=672e29d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672e29d7",
  null
  
)

export default component.exports